export const TOUR_Z_INDEX = 10000
export const TOUR_DEFAULT_OVERLAY_BACKGROUND =
  'linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.8) 100%), rgba(255, 214, 0, 0.50)'
